interface ConstructorOptions {
  preSizing?: boolean;
  sizing?: boolean;
  pvCurve?: boolean;
}

interface Invalidations {
  invalidateReports: () => Promise<void>;
  invalidateSizing: () => Promise<void>;
  invalidatePreSizing: () => Promise<void>;
  invalidatePVCurve: () => Promise<void>;
}

export class Invalidation {
  private readonly preSizing: boolean;
  private readonly sizing: boolean;
  private readonly pvCurve: boolean;

  constructor(options: ConstructorOptions = {}) {
    this.preSizing = options.preSizing ?? true;
    this.sizing = options.sizing ?? true;
    this.pvCurve = options.pvCurve ?? false;
  }

  public async invalidate({ invalidateReports, invalidateSizing, invalidatePreSizing, invalidatePVCurve }: Invalidations): Promise<void> {
    const promises = [];
    promises.push(invalidateReports());
    if (this.sizing) {
      promises.push(invalidateSizing());
    }
    if (this.preSizing) {
      promises.push(invalidatePreSizing());
    }
    if (this.pvCurve) {
      promises.push(invalidatePVCurve());
    }
    await Promise.all(promises);
  }
}
